<template>
  <div class="sound-setup-rubetek">
    <div class="sound-setup-rubetek__header">
      <v-icon color="primary" class="sound-setup-rubetek__header-icon">mdi-volume-high</v-icon>
      <h2 class="sound-setup-rubetek__title">Настройки звука</h2>
    </div>
    <v-form ref="formSoundDoorphone" v-model="validSound" lazy-validation>
      <v-row>
        <v-col cols="12" md="6" class="pb-0">
          <v-row>
            <v-col cols="12" class="py-0 pt-2">
              <v-text-field
                v-model="formSound.soundVolume"
                flat
                outlined
                dense
                type="number"
                label="Чувствительность микрофона"
                :rules="rules.VolumeRubetek"
                prepend-inner-icon="mdi-microphone"
                class="sound-setup-rubetek__field"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formSound.speakerVolume"
                flat
                outlined
                dense
                type="number"
                label="Громкость динамика"
                :rules="rules.VolumeRubetek"
                prepend-inner-icon="mdi-volume-high"
                class="sound-setup-rubetek__field"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formSound.echoStopperVolume"
                flat
                outlined
                dense
                type="number"
                label="Уровень эхоподавления"
                :rules="rules.number"
                prepend-inner-icon="mdi-waveform"
                class="sound-setup-rubetek__field"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formSound.version"
                flat
                outlined
                dense
                label="Версия оборудования"
                :disabled="true"
                prepend-inner-icon="mdi-chip"
                class="sound-setup-rubetek__field"
              />
            </v-col>
            <v-col cols="12" class="py-0 pl-4">
              <div class="sound-setup-rubetek__switch-wrap">
                <v-icon left color="primary" small>mdi-door-open</v-icon>
                <v-switch
                  v-model="formSound.closingDoor"
                  flat
                  inset
                  label="Звук открытия двери"
                  class="sound-setup-rubetek__switch mt-0"
                  hide-details
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    <div class="sound-setup-rubetek__actions">
      <v-btn
        color="primary"
        class="text-none"
        rounded
        :disabled="!validSound"
        @click="validateSoundSettings()"
      >
        <v-icon left>mdi-content-save-outline</v-icon>
        Сохранить
      </v-btn>
      <v-btn
        color="primary"
        outlined
        rounded
        class="text-none ml-2"
        @click.prevent="returnDoorphone()"
      >
        <v-icon left>mdi-close</v-icon>
        Отменить
      </v-btn>
    </div>
    </v-form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import { rules } from '../../../consts';

export default {
  name: 'SoundSetup',
  data: () => {
    return {
      validSound: true,
      rules,
      formSound: {
        echoStopperVolume: '',
        soundVolume: '',
        closingDoor: false,
        speakerVolume: '',
        version: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      soundSettings: 'Doorphone/soundSettings',
    }),
  },
  methods: {
    ...mapActions({
      getSoundSettings: 'Doorphone/getSoundSettings',
      updateSoundSettings: 'Doorphone/updateSoundSettings',
    }),
    returnDoorphone () {
      this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
    },
    validateSoundSettings () {
      if (this.$refs.formSoundDoorphone.validate()) {
        const dataSound = {
          cHandoffSendVolume: this.formSound.soundVolume,
          cSpeakerVolume: this.formSound.speakerVolume,
          cAECLevel: this.formSound.echoStopperVolume,
        };
        this.formSound.closingDoor ? dataSound.cOpenDoorWarning = '1' : dataSound.cOpenDoorWarning = '0';
        this.updateSoundSettings({
          id: this.$route.params.id,
          settings: dataSound,
        })
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
          })
          .catch((e) => {
            if (e.length > 0) {
              e.forEach((message) => {
                this.$flash_warning(message);
              });
            } else {
              this.$flash_warning('Ошибка при смене настроек звука');
            }
          });
      } else {
        this.$flash_warning('Заполните все поля');
      }
    },
  },
  created () {
    this.getSoundSettings(this.$route.params.id)
      .then(() => {
        this.formSound.soundVolume = this.soundSettings.cHandoffSendVolume;
        this.formSound.speakerVolume = this.soundSettings.cSpeakerVolume;
        this.formSound.echoStopperVolume = this.soundSettings.cAECLevel;
        this.formSound.version = this.soundSettings.cGolbalHDVersion;

        this.formSound.closingDoor = this.soundSettings.cOpenDoorWarning === '1';
      });
  },

};
</script>

<style lang="scss" scoped>
.sound-setup-rubetek__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.sound-setup-rubetek__header-icon {
  flex-shrink: 0;
}

.sound-setup-rubetek__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.sound-setup-rubetek__field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}

.sound-setup-rubetek__switch-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.sound-setup-rubetek__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 40px;
}
</style>
